import { render } from "./WorkbookResult.vue?vue&type=template&id=2d8fbebe"
import script from "./WorkbookResult.vue?vue&type=script&lang=js"
export * from "./WorkbookResult.vue?vue&type=script&lang=js"

import "./WorkbookResult.vue?vue&type=style&index=0&id=2d8fbebe&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__